import { put, takeEvery } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { MICROACTIONS_PATH } from 'app/constants/navLinks.js'

import { createOrganization, updateOrganization } from '../actions'

export function* handleSaveOrgSuccess({ payload }) {
  yield put(push(`${MICROACTIONS_PATH}/organizations`))
}

export default function* takeEverySaveOrganizationSuccess() {
  yield takeEvery([createOrganization.success.toString(), updateOrganization.success.toString()], handleSaveOrgSuccess)
}
